<template>
  <CRow>
    <CCol col="4" >
    <CCard>   
    <CCardHeader><b>Personal Info</b> </CCardHeader>
      <CListGroup >
        <CListGroupItem href="#"> Name :  {{ datas.data.fullname }} </CListGroupItem>
        <CListGroupItem href="#"> Email :  {{ datas.data.email }} </CListGroupItem>
        <CListGroupItem href="#"> Gender :  {{ datas.data.gender }} </CListGroupItem>
        <CListGroupItem href="#"> Teacher :  {{ datas.data.teacher_name[0][0] }} </CListGroupItem>
        
      </CListGroup>
    </CCard>
    <CCard>   
    <CCardHeader><b>Result</b></CCardHeader>
      <CListGroup >
        <CListGroupItem v-for="item in datas.data.get_result " :key="item.id">
        <div>
        <CRow>
          <CCol class="col-10">
            <div>{{ item.r1 }}</div>
            <div>{{ item.r2 }}</div>
            <div>{{ item.r3 }}</div>
          </CCol>
        </CRow>
        </div>
        </CListGroupItem>  
         </CListGroup>
    </CCard>
    <CCard>   
    <CCardHeader><b>Result Photo</b></CCardHeader>
      <CListGroup >
        <CListGroupItem>
          <img v-bind:src="getPhoto(datas.data.get_photo)" width="100%">
        </CListGroupItem>  
         </CListGroup>
    </CCard>
    </CCol>
    <CCol col="8" >
      <CCard>
         <CCardHeader><b>Answer Detail</b></CCardHeader>
          <CCardBody>
            
            <!-- <label>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.</label> -->
              
                <table class="mt-3 col-12"  v-for="i in datas.data.get_answer" :key="i.id">
                <thead>
                  <tr >
                    <th v-for="item in fields_answer" :key="item.title">
                    {{ item.title }}
                    </th>
                  </tr>
                </thead>
              <tbody>
                <tr >
                  <td v-if="i.rm === i.qm1" class="text-danger"> {{ i.qm1.substr(0,1) == "b" ? "*" : i.qm1.substr(0,1) }} </td> <td v-else> {{ i.qm1.substr(0,1) == "b" ? "*" : i.qm1.substr(0,1) }} </td>
                  <td v-if="i.rl === i.ql1" class="text-danger"> {{ i.ql1.substr(0,1) == "b" ? "*" : i.ql1.substr(0,1) }} </td> <td v-else> {{ i.ql1.substr(0,1) == "b" ? "*" : i.ql1.substr(0,1) }} </td>
                  <td> {{ i.q1 }} </td>
                  </tr>
                  <tr>
                  <td v-if="i.rm === i.qm2" class="text-danger"> {{ i.qm2.substr(0,1) == "b" ? "*" : i.qm2.substr(0,1) }} </td><td v-else> {{ i.qm2.substr(0,1) == "b" ? "*" : i.qm2.substr(0,1) }} </td>
                  <td v-if="i.rl === i.ql2" class="text-danger"> {{ i.ql2.substr(0,1) == "b" ? "*" : i.ql2.substr(0,1) }} </td><td v-else> {{ i.ql2.substr(0,1) == "b" ? "*" : i.ql2.substr(0,1) }} </td>
                  <td> {{ i.q2 }} </td>
                  </tr>
                  <tr>
                  <td v-if="i.rm === i.qm3" class="text-danger"> {{ i.qm3.substr(0,1) == "b" ? "*" : i.qm3.substr(0,1) }} </td><td v-else>{{ i.qm3.substr(0,1) == "b" ? "*" : i.qm3.substr(0,1) }} </td>
                  <td v-if="i.rl === i.ql3" class="text-danger"> {{ i.ql3.substr(0,1) == "b" ? "*" : i.ql3.substr(0,1) }} </td><td v-else>{{ i.ql3.substr(0,1) == "b" ? "*" : i.ql3.substr(0,1) }} </td>
                  <td> {{ i.q3 }} </td>
                  </tr>
                  <tr>
                  <td v-if="i.rm === i.qm4" class="text-danger"> {{ i.qm4.substr(0,1) == "b" ? "*" : i.qm4.substr(0,1) }} </td><td v-else> {{ i.qm4.substr(0,1) == "b" ? "*" : i.qm4.substr(0,1) }} </td>
                  <td v-if="i.rl === i.ql4" class="text-danger"> {{ i.ql4.substr(0,1) == "b" ? "*" : i.ql4.substr(0,1) }} </td><td v-else> {{ i.ql4.substr(0,1) == "b" ? "*" : i.ql4.substr(0,1) }} </td>
                  <td> {{ i.q4 }} </td>
                  </tr>
                  
              </tbody>
              
              </table>

            
          </CCardBody>
        </CCard>
    </CCol>
 
    <alertmodal></alertmodal>
  </CRow>

</template>

<script>  
import moment from 'moment';
import EventBus from '@/eventBus';
import alertmodal from '@/views/alert/modal.vue';

import onlineclass from '@/services/onlineclass';
import report from '@/services/report';

import ikid from '@/services/ikid'
import axios from 'axios'

import store from '@/store.js'

export default {
name: 'detailmodal',
components: {  alertmodal },
  data () {
    return {
      accordion: '',
      mode: '',
      datas:[],
      dob:'',
      dad:'',
      mom:'',
      form:{
        uuid:''
      },
      fields_answer:[ 
        {title: 'Most', sortable: false, },
        {title: 'Least', sortable: false},
        {title: 'Question', sortable: false},
      ],
      }
  },
  mounted(){
    this.load()
    EventBus.$on('TABLE_UPDATE', (data) => {
      if(data){
          this.load();
          console.log('load mounted')  
      }
    });
  },  
  
  beforeDestroy(){
    EventBus.$off('TABLE_UPDATE', this.listener)  
    console.log('OFF_OPEN_MODAL_IKID')
   },
 methods:{

   
   getPhoto(data){
      //console.log('get - photo')
        if (data){
            return axios.defaults.baseURL + '/getfile/' + data.path + '/' + data.filename
        }else{
            return axios.defaults.baseURL + '/getfile/memberphoto/no_photo.jpg'
        } 
     
    },    
    openModalEdit(id){
      //SET PERMISSION EACH FEATURE
      let Permission = store.state.user.authenticated.permission
      if (typeof Permission != 'undefined') {
        if(Permission.indexOf('Create/edit kid (including edit class/parents/etc)') !== -1){
          //IF ALLOW
        var params = {title: 'Edit Kid', mode:'edit', data:id}
        EventBus.$emit('OPEN_MODAL_IKID', params)
        //END ALLOW
        }else{
          //IF NOT
          var params = {title: 'Error', mode:'danger', data:'unautenticated'}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
          console.log(' open modal edit')
        } 
      }
      //SET END
        console.log('load edit-detail-ikid')
       
    },
    openModalEditPhoto(id){
      //SET PERMISSION EACH FEATURE
      let Permission = store.state.user.authenticated.permission
      if (typeof Permission != 'undefined') {
        if(Permission.indexOf('Create/edit kid (including edit class/parents/etc)') !== -1){
          //IF ALLOW
        var params = {title: 'Edit Kid Photo', mode:'edit', data:id}
        EventBus.$emit('OPEN_MODAL_IKID_PHOTO', params)
        //END ALLOW
        }else{
          //IF NOT
          var params = {title: 'Error', mode:'danger', data:'unautenticated'}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
          console.log(' open modal edit')
        } 
      }
      //SET END
        console.log('load edit photo')
        
    },
    openModalEditNote(id){
      //SET PERMISSION EACH FEATURE
      let Permission = store.state.user.authenticated.permission
      if (typeof Permission != 'undefined') {
        if(Permission.indexOf('Add/edit kid note') !== -1){
          //IF ALLOW
        var params = {title: 'Edit Kid Note', mode:'edit', data:id}
        EventBus.$emit('OPEN_MODAL_IKID_NOTE', params)
        //END ALLOW
        }else{
          //IF NOT
          var params = {title: 'Error', mode:'danger', data:'unautenticated'}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
          console.log(' open modal edit')
        } 
      }
      //SET END
        console.log('load edit note')
    },
    openModalNewNote(){
      //SET PERMISSION EACH FEATURE
      let Permission = store.state.user.authenticated.permission
      if (typeof Permission != 'undefined') {
        if(Permission.indexOf('Add/edit kid note') !== -1){
          //IF ALLOW
        var params = {title: 'New Kid Note', mode:'create'}
        EventBus.$emit('OPEN_MODAL_IKID_NOTE', params)
        //END ALLOW
        }else{
          //IF NOT
          var params = {title: 'Error', mode:'danger', data:'unautenticated'}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
          console.log(' open modal edit')
        } 
      }
      //SET END
        console.log('load new note')
    },
    destroyNote(id){
      //SET PERMISSION EACH FEATURE
      let Permission = store.state.user.authenticated.permission
      if (typeof Permission != 'undefined') {
        if(Permission.indexOf('Delete kid note') !== -1){
          //IF ALLOW
      if(confirm("Do you really want to delete this note?")){
        ikid.deleteIkidNote(id)
        .then(res => {
          EventBus.$emit('TABLE_UPDATE', true)
          var params = {title: 'Success', mode:'success', data:res.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        }).catch ((err) => {
          var params = {title: 'Error', mode:'danger', data:err.response.data.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
          
          console.log('load delete note')
        })
        //END ALLOW
        }else{
          //IF NOT
          var params = {title: 'Error', mode:'danger', data:'unautenticated'}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
          console.log(' open modal edit')
        } 
      }
      //SET END
      } 
    },
    
  
    load(){
      console.log('load ikidbyid')
        onlineclass.getResultDiscbyID(this.$route.query.id)
        .then(res => {
            this.datas = res;
            
            
        }).catch ((err) => {
            var params = {title: 'Error', mode:'danger', data:err.response.data.message}
            EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
        
    },
   
    
  }  
}

</script>
